module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_04 (1).152a01a1.png";